
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"120","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".5","stroke":"#121131","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"60","cy":"60","r":"45"}}),_c('path',{attrs:{"d":"M60.001 71.59c9.038 0 16.364-7.326 16.364-16.363 0-9.037-7.326-16.364-16.364-16.364-9.037 0-16.363 7.327-16.363 16.364S50.964 71.59 60 71.59zM87.894 93.745a28.636 28.636 0 00-55.789 0"}})])])
          )
        }
      }
    